/* Everwhim World interactions (Phase 1.5 + Style Profile + Style Edit hand-off, DEV). Vanilla JS, no dependencies.
   Privacy: journey answers live in memory only (no cookies/storage). They leave the page only when the
   customer presses the Style Edit buy button, as line-item properties on her own cart line. */
(function () {
  'use strict';
  var d = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;

  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }

  /* ---------- Header: overlay on dark openers, solid elsewhere ---------- */
  function initHeader() {
    var header = d.querySelector('[data-ew-header]');
    if (!header) return;
    var first = d.querySelector('#MainContent > .shopify-section');
    var dark = first && first.querySelector('[data-ew-dark]');
    if (!dark) {
      header.classList.add('is-solid');
      d.body.classList.add('ew-has-solid');
      return;
    }
    var limit = function () { return Math.max(80, dark.offsetHeight - 120); };
    var ticking = false;
    function update() {
      header.classList.toggle('is-solid', window.scrollY > limit());
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Dialogs: menu + product drawers ---------- */
  function openDialog(dlg, opener) {
    if (!dlg || dlg.open) return;
    dlg._opener = opener || null;
    if (typeof dlg.showModal === 'function') { dlg.showModal(); } else { dlg.setAttribute('open', ''); }
    d.body.style.overflow = 'hidden';
  }
  function initDialogs() {
    d.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-ew-open]');
      if (opener) {
        var dlg = d.getElementById(opener.getAttribute('data-ew-open'));
        if (dlg && dlg.tagName === 'DIALOG') { e.preventDefault(); openDialog(dlg, opener); return; }
      }
      var closer = e.target.closest('[data-ew-close]');
      if (closer) { var c = closer.closest('dialog'); if (c) c.close(); return; }
      if (e.target.tagName === 'DIALOG' && e.target.open) { e.target.close(); return; }
      var inMenuLink = e.target.closest('.ew-menu a');
      if (inMenuLink) { var m = inMenuLink.closest('dialog'); if (m) m.close(); }
    });
    $all('dialog').forEach(function (dlg) {
      dlg.addEventListener('close', function () {
        d.body.style.overflow = '';
        if (dlg._opener && dlg._opener.focus) dlg._opener.focus();
        if (location.hash === '#' + dlg.id && history.replaceState) history.replaceState(null, '', location.pathname + location.search);
      });
    });
    /* Deep link: /pages/...#piece-name opens that piece's drawer (social links) */
    if (location.hash) {
      var target = d.getElementById(location.hash.slice(1));
      if (target && target.tagName === 'DIALOG') setTimeout(function () { openDialog(target); }, 400);
    }
  }

  /* ---------- Tap to reveal Darcy's note ---------- */
  function initNotes() {
    d.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ew-note-toggle]');
      if (!btn) return;
      var note = d.getElementById(btn.getAttribute('aria-controls'));
      if (!note) return;
      var show = note.hasAttribute('hidden');
      if (show) note.removeAttribute('hidden'); else note.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', show ? 'true' : 'false');
      var label = btn.querySelector('[data-label]');
      if (label) label.textContent = show ? (btn.getAttribute('data-close-label') || 'Close') : (btn.getAttribute('data-open-label') || "Darcy's note");
    });
  }

  /* ---------- Scroll reveals ---------- */
  function initReveal() {
    var els = $all('[data-ew-reveal]');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Video: muted loops only in view; respect reduced motion + data saver ---------- */
  function initVideo() {
    var vids = $all('video[data-ew-autoplay]');
    if (!vids.length) return;
    if (reduce || saveData || !('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.setAttribute('controls', ''); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () { v.setAttribute('controls', ''); }); }
        else { v.pause(); }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { v.muted = true; io.observe(v); });
  }

  /* ---------- Current Edit: swipe counter ---------- */
  function initTracks() {
    $all('[data-ew-track]').forEach(function (track) {
      var wrap = track.closest('[data-ew-edit]');
      var counter = wrap && wrap.querySelector('[data-ew-count]');
      var bar = wrap && wrap.querySelector('[data-ew-bar]');
      var items = track.children;
      if (!counter || !items.length) return;
      function update() {
        var w = items[0].getBoundingClientRect().width || 1;
        var i = Math.min(items.length, Math.round(track.scrollLeft / (w + 16)) + 1);
        counter.textContent = (i < 10 ? '0' : '') + i;
        if (bar) bar.style.setProperty('--p', Math.round(i / items.length * 100) + '%');
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }

  /* ---------- The Look: markers <-> pieces ---------- */
  function initLooks() {
    $all('[data-ew-look]').forEach(function (look) {
      var markers = $all('[data-ew-marker]', look);
      var pieces = $all('[data-ew-piece]', look);
      function activate(n, scroll) {
        markers.forEach(function (m) { var on = m.getAttribute('data-ew-marker') === n; m.classList.toggle('is-active', on); m.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        pieces.forEach(function (p) {
          var on = p.getAttribute('data-ew-piece') === n;
          p.classList.toggle('is-active', on);
          if (on && scroll) p.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        });
      }
      markers.forEach(function (m) { m.addEventListener('click', function () { activate(m.getAttribute('data-ew-marker'), true); }); });
      pieces.forEach(function (p) {
        p.addEventListener('mouseenter', function () { activate(p.getAttribute('data-ew-piece'), false); });
        p.addEventListener('focus', function () { activate(p.getAttribute('data-ew-piece'), false); });
      });
      var addAll = look.querySelector('[data-ew-add-look]');
      if (addAll) addAll.addEventListener('click', function () {
        var ids = (addAll.getAttribute('data-ew-add-look') || '').split(',').filter(Boolean);
        if (!ids.length) return;
        addAll.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) }) })
          .then(function (r) { if (!r.ok) throw new Error(); window.location.href = '/cart'; })
          .catch(function () { addAll.removeAttribute('aria-busy'); alert('Sorry, one of these pieces is no longer available.'); });
      });
    });
  }

  /* ---------- Styling journey (prototype: in-memory only) ----------
     Each answer set is keyed by a Style Profile V1 field name (data-ew-key):
     occasions, aesthetics, sourcing_preference, avoid, feel, budget_per_piece,
     top_size, bottom_size, dress_size, shoe_size, wardrobe_staples, notes_from_customer.
     A step can hold several keyed groups (sizes). Labels feed Darcy's summary; values are
     stable codes for the Style Profile. Sent only by initStyleEditBuy, on purchase. */
  function initJourneys() {
    $all('[data-ew-journey]').forEach(function (j) {
      var steps = $all('[data-ew-step]', j);
      var bgImgs = $all('[data-ew-bg] img', j);
      var bar = j.querySelector('[data-ew-progress-bar]');
      var label = j.querySelector('[data-ew-progress-label]');
      var total = steps.filter(function (s) { return s.hasAttribute('data-ew-question'); }).length;
      var labels = {};
      var values = {};
      var current = 0;
      var bgIndex = 0;

      function swapBg(src) {
        if (!src || bgImgs.length < 2) return;
        var next = bgImgs[bgIndex === 0 ? 1 : 0];
        if (next.getAttribute('src') === src && next.classList.contains('is-on')) return;
        next.onload = function () {
          bgImgs.forEach(function (im) { im.classList.remove('is-on'); });
          next.classList.add('is-on');
          bgIndex = bgImgs.indexOf(next);
        };
        next.setAttribute('src', src);
      }

      function stepHasAnswer(step) {
        return $all('[data-ew-key]', step).concat(step.hasAttribute('data-ew-key') ? [step] : []).some(function (g) {
          var k = g.getAttribute('data-ew-key');
          return labels[k] && labels[k].length;
        });
      }

      function refreshNext(step) {
        var next = step.querySelector('[data-ew-next]');
        if (!next || !next.hasAttribute('data-skip')) return;
        next.textContent = stepHasAnswer(step) ? (next.getAttribute('data-ready') || 'Continue') : (next.getAttribute('data-skip') || 'Skip');
      }

      function render(n) {
        current = Math.max(0, Math.min(n, steps.length - 1));
        steps.forEach(function (s, i) { if (i === current) s.removeAttribute('hidden'); else s.setAttribute('hidden', ''); });
        var step = steps[current];
        var qIndex = steps.slice(0, current + 1).filter(function (s) { return s.hasAttribute('data-ew-question'); }).length;
        if (bar) bar.style.width = (step.hasAttribute('data-ew-question') ? Math.round(qIndex / total * 100) : (current === 0 ? 0 : 100)) + '%';
        if (label) label.textContent = step.hasAttribute('data-ew-question') ? (qIndex + ' of ' + total) : (current === 0 ? 'Begin' : 'Your story');
        if (step.hasAttribute('data-ew-final')) buildSummary(step);
        refreshNext(step);
        var bg = step.getAttribute('data-ew-step-bg');
        if (bg) swapBg(bg);
        var h = step.querySelector('[data-ew-focus]');
        if (h && current > 0 && h.focus) { h.focus({ preventScroll: true }); }
        if (current > 0 && window.scrollTo) {
          var top = j.getBoundingClientRect().top + window.scrollY - 60;
          if (window.innerWidth < 990 && Math.abs(window.scrollY - top) > 40) window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        }
      }

      function buildSummary(step) {
        var list = step.querySelector('[data-ew-summary]');
        if (!list) return;
        list.innerHTML = '';
        $all('[data-ew-key]', j).forEach(function (g) {
          var key = g.getAttribute('data-ew-key');
          if (!labels[key] || !labels[key].length) return;
          var li = d.createElement('li');
          var sp = d.createElement('span'); sp.textContent = g.getAttribute('data-ew-summary-label') || key;
          var b = d.createElement('b'); b.textContent = labels[key].join(', ');
          li.appendChild(sp); li.appendChild(b); list.appendChild(li);
        });
        var empty = step.querySelector('[data-ew-summary-empty]');
        if (empty) empty.hidden = list.children.length > 0;
      }

      function choose(opt) {
        var group = opt.closest('[data-ew-key]');
        if (!group) return;
        var step = opt.closest('[data-ew-step]');
        var key = group.getAttribute('data-ew-key');
        var multi = group.hasAttribute('data-ew-multi');
        var pressed = opt.getAttribute('aria-pressed') === 'true';
        var opts = $all('[data-ew-opt]', group).filter(function (o) { return o.closest('[data-ew-key]') === group; });
        if (!multi) opts.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        var nowOn = !pressed; /* tap again to clear, in single- and multi-choice groups alike */
        opt.setAttribute('aria-pressed', nowOn ? 'true' : 'false');
        var on = opts.filter(function (o) { return o.getAttribute('aria-pressed') === 'true'; });
        labels[key] = on.map(function (o) { return o.getAttribute('data-ew-opt'); });
        values[key] = on.map(function (o) { return o.getAttribute('data-ew-value') || o.getAttribute('data-ew-opt'); });
        var img = opt.getAttribute('data-ew-img');
        if (img && opt.getAttribute('aria-pressed') === 'true') swapBg(img);
        refreshNext(step);
        announce(key);
      }

      function announce(key) {
        try { j.dispatchEvent(new CustomEvent('ew:answer', { bubbles: true, detail: { key: key } })); } catch (err) {}
      }

      j.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-ew-opt]');
        if (opt) { choose(opt); return; }
        if (e.target.closest('[data-ew-next]')) { render(current + 1); return; }
        if (e.target.closest('[data-ew-back]')) { render(current - 1); return; }
        if (e.target.closest('[data-ew-restart]')) {
          labels = {}; values = {};
          $all('[data-ew-opt]', j).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          $all('[data-ew-text]', j).forEach(function (t) { t.value = ''; t.dispatchEvent(new Event('input', { bubbles: true })); });
          render(0);
          announce('*');
        }
      });

      /* Optional short note */
      j.addEventListener('input', function (e) {
        var t = e.target.closest('[data-ew-text]');
        if (!t) return;
        var group = t.closest('[data-ew-key]');
        var key = group.getAttribute('data-ew-key');
        var v = t.value.replace(/\s+/g, ' ').trim();
        labels[key] = v ? [v.length > 90 ? v.slice(0, 90) + '…' : v] : [];
        values[key] = v ? [t.value.trim()] : [];
        var counter = group.querySelector('[data-ew-count-chars]');
        if (counter) counter.textContent = t.value.length + ' / ' + (t.getAttribute('maxlength') || '');
        refreshNext(t.closest('[data-ew-step]'));
        announce(key);
      });

      /* Read-only snapshot of codes (kept for compatibility). */
      j.ewSnapshot = function () {
        var out = {};
        Object.keys(values).forEach(function (k) { if (values[k].length) out[k] = values[k].slice(); });
        return out;
      };
      /* Answers with both stable codes and the words she tapped (full text for the note). Skipped keys are absent. */
      j.ewAnswers = function () {
        var out = {};
        Object.keys(values).forEach(function (k) {
          if (!values[k].length) return;
          out[k] = { codes: values[k].slice(), labels: (k === 'notes_from_customer' ? values[k] : labels[k]).slice() };
        });
        return out;
      };
      j.ewGoTo = function (key) {
        var g = j.querySelector('[data-ew-key="' + key + '"]');
        var st = g && (g.hasAttribute('data-ew-step') ? g : g.closest('[data-ew-step]'));
        if (st) render(steps.indexOf(st));
      };

      render(0);
    });
  }

  /* ---------- Personal Style Edit: journey -> variant -> cart -> checkout ---------- */
  var EW_ORDER_FIELDS = [
    ['occasions', 'Dressing for'],
    ['aesthetics', 'Drawn to'],
    ['avoid', 'Please avoid'],
    ['feel', 'Wants to feel'],
    ['budget_per_piece', 'Budget per piece'],
    ['sizes', 'Sizes'],
    ['wardrobe_staples', 'Already loves'],
    ['notes_from_customer', 'Note to Darcy']
  ];
  var EW_SIZE_FIELDS = [['top_size', 'Top'], ['bottom_size', 'Bottom'], ['dress_size', 'Dress'], ['shoe_size', 'Shoe']];

  function ewOrderPayload(answers) {
    var a = answers || {};
    var first = function (k) { return a[k] && a[k].codes.length ? a[k].codes[0] : ''; };
    var props = {};
    var sizes = EW_SIZE_FIELDS.filter(function (f) { return a[f[0]]; }).map(function (f) { return f[1] + ' ' + a[f[0]].labels[0]; });
    EW_ORDER_FIELDS.forEach(function (f) {
      var v = f[0] === 'sizes' ? sizes.join(' · ') : (a[f[0]] ? a[f[0]].labels.join(', ') : '');
      if (v) props[f[1]] = v;
    });
    var codes = { v: 1, created_from: 'styling', sourcing_this_edit: first('sourcing_preference') };
    ['occasions', 'aesthetics', 'avoid', 'feel', 'wardrobe_staples'].forEach(function (k) { if (a[k]) codes[k] = a[k].codes.slice(); });
    ['budget_per_piece', 'top_size', 'bottom_size', 'dress_size', 'shoe_size'].forEach(function (k) { if (first(k)) codes[k] = first(k); });
    if (a.notes_from_customer) codes.notes_from_customer = a.notes_from_customer.codes[0];
    props._ew_profile = JSON.stringify(codes);
    return { sourcing: codes.sourcing_this_edit, properties: props };
  }

  function initStyleEditBuy() {
    $all('[data-ew-buy]').forEach(function (btn) {
      var root = btn.closest('section') || d;
      var mapEl = root.querySelector('[data-ew-buy-variants]');
      var status = root.querySelector('[data-ew-buy-status]');
      var choice = root.querySelector('[data-ew-buy-choice]');
      var variants = {};
      try { variants = JSON.parse(mapEl.textContent); } catch (err) { return; }
      var journey = d.querySelector('[data-ew-journey]');
      var label = btn.textContent;

      function say(msg) { if (status) { status.textContent = msg; status.hidden = !msg; } }
      function current() { return journey && journey.ewAnswers ? journey.ewAnswers() : {}; }
      function showChoice() {
        if (!choice) return;
        var src = current().sourcing_preference;
        var name = src ? src.labels[0] : '';
        var out = choice.querySelector('[data-ew-buy-choice-name]');
        if (out) out.textContent = name;
        choice.hidden = !name;
        if (name) say('');
      }
      if (journey) journey.addEventListener('ew:answer', showChoice);
      showChoice();

      root.addEventListener('click', function (e) {
        var ch = e.target.closest('[data-ew-buy-change]');
        if (!ch || !journey || !journey.ewGoTo) return;
        e.preventDefault();
        journey.ewGoTo('sourcing_preference');
        journey.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });

      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-busy') === 'true') return;
        var payload = ewOrderPayload(current());
        var v = variants[payload.sourcing];
        if (!payload.sourcing || !v) {
          say(btn.getAttribute('data-msg-choose') || 'First, tell Darcy how to shop your story.');
          if (journey && journey.ewGoTo) {
            journey.ewGoTo('sourcing_preference');
            journey.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          }
          return;
        }
        if (!v.available) { say(btn.getAttribute('data-msg-full') || 'This Style Edit is full right now.'); return; }
        btn.setAttribute('aria-busy', 'true'); btn.disabled = true; btn.textContent = btn.getAttribute('data-msg-busy') || 'One moment…';
        say('');
        var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root_url + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: payload.properties }] })
        }).then(function (r) {
          return r.json().then(function (body) { return { ok: r.ok, body: body }; });
        }).then(function (res) {
          if (!res.ok) throw res.body;
          window.location.href = root_url + 'checkout';
        }).catch(function (err) {
          btn.removeAttribute('aria-busy'); btn.disabled = false; btn.textContent = label;
          var full = err && (err.status === 422 || /sold out|not available|already sold/i.test(err.description || err.message || ''));
          say(full ? (btn.getAttribute('data-msg-full') || 'This Style Edit is full right now.') : (btn.getAttribute('data-msg-error') || 'Something went wrong. Please try again.'));
        });
      });
    });
  }
  window.EverwhimStyleEdit = { payload: ewOrderPayload };

  function init() {
    initHeader();
    initDialogs();
    initNotes();
    initReveal();
    initVideo();
    initTracks();
    initLooks();
    initJourneys();
    initStyleEditBuy();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
